module.exports = "/static/assets/3cbe5be8dba7df255a9049fa3db394d4.gif";